<template>
  <div class="dropdown dropdown--checkbox" v-click-away="hideDropdown" v-cloak>
    <!-- Dropdown button -->
    <button
      type="button"
      class="dropdown__link dropdown__link--checkbox"
      :class="{ 'dropdown__link--active': openDropdown }"
      @click="toggleDropdown"
    >
      <span class="font-medium text-gray-600" v-html="dropdownName"></span>
      <i class="icon icon--arrow-down"></i>
    </button>

    <input type="hidden" name="selectedRegions" :value="selectedRegions.join(',')">

    <!-- Dropdown content -->
    <transition name="fade">
      <div v-if="openDropdown" class="dropdown__holder dropdown__holder--checkbox">
        <div class="dropdown__list-container">
          <ul class="dropdown__list mb-3">
            <li
              v-for="region in firstColumn"
              :key="region"
              class="dropdown__list-item dropdown__list-item--checkbox"
            >
              <div class="checkbox-custom">
                <input
                  type="checkbox"
                  class="subscribe"
                  :value="region"
                  :id="region"
                  v-model="selectedRegions"
                >
                <label class="form-check-label" :for="region">{{ region }}</label>
              </div>
            </li>
          </ul>
          <ul class="dropdown__list mb-3">
            <li
              v-for="region in secondColumn"
              :key="region"
              class="dropdown__list-item dropdown__list-item--checkbox"
            >
              <div class="checkbox-custom">
                <input
                  type="checkbox"
                  class="subscribe"
                  :value="region"
                  :id="region"
                  v-model="selectedRegions"
                >
                <label class="form-check-label" :for="region">{{ region }}</label>
              </div>
            </li>
          </ul>
        </div>
        <div class="ml-3 mr-3">
          <button
            type="button"
            class="btn btn--green btn--done btn--auto-width"
            @click="hideDropdown"
          >
            Done
            <i class="icon icon--arrow-down"></i>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  regions: {
    type: Array,
    default: () => [],
  },
});

const selectedRegions = ref([]);
const openDropdown = ref(false);

const dropdownName = computed(() => {
  if (selectedRegions.value.length === 0) {
    return 'Regions of interest <span class="text-red-500">*</span>';
  }
  if (selectedRegions.value.length > 2) {
    return `${selectedRegions.value.length} regions selected`;
  }
  return selectedRegions.value.join(', ');
});

const toggleDropdown = () => {
  openDropdown.value = !openDropdown.value;
};

const hideDropdown = () => {
  openDropdown.value = false;
};

const firstColumn = computed(() => {
  const half = Math.ceil(props.regions.length / 2);
  return props.regions.slice(0, half);
});

const secondColumn = computed(() => {
  const half = Math.ceil(props.regions.length / 2);
  return props.regions.slice(half);
});

</script>
